<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="!$route.query.jobId" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.jobId == undefined && !$route.path.includes('newjob')">

      <template v-slot:filter>

        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>

            <FilterGroup v-if="!hideJobDetailsFilters" :title="$t('servicesystem.common_objects.commonterms.details')"
              :applied-filters="[jobtypefilter, hidecompletedjobsfilter, jobstatusfilter, jobsubstatusfilter, jobpriorityfilter, supplierfailurecodefilter, repaircodefilter]"
              style="border-top: none;">
              <QAutoComplete v-model="jobtypefilter" :label="$t('servicesystem.common_objects.job.type')"
                :list="jobTypeList" :textkey="'Name'" :valuekey="'Id'" clearable multiple externaledit class="mb-3">
              </QAutoComplete>
              <v-checkbox v-if="!routeStatusId" v-model="hidecompletedjobsfilter"
                :label="$t('servicesystem.common_objects.job.only_not_complete')" dense hide-details
                class="pt-0 mt-n1 ml-n1 mb-2">
              </v-checkbox>
              <JobStatusSelect v-model="jobstatusfilter" multiple clearable externaledit class="mb-3">
              </JobStatusSelect>
              <JobSubStatusSelect v-model="jobsubstatusfilter" :key="statusKey"
                :filter="{ JobStatusIdList: jobstatusfilter }" multiple clearable externaledit class="mb-3">
              </JobSubStatusSelect>
              <QAutoComplete v-model="jobpriorityfilter" :label="$t('servicesystem.common_objects.job.priority')"
                :list="jobPriorityList" :textkey="'Name'" :valuekey="'Id'" clearable multiple externaledit class="mb-3">
              </QAutoComplete>
              <SupplierFailureCodeSelect v-model="supplierfailurecodefilter" clearable multiple externaledit
                class="mb-3">
              </SupplierFailureCodeSelect>
              <RepairCodeSelect v-model="repaircodefilter" clearable multiple externaledit>
              </RepairCodeSelect>
            </FilterGroup>

            <FilterGroup v-if="!hideProductFilters" :title="$t('servicesystem.common_objects.machine.product')"
              :open="false" :applied-filters="[machinetypesfilter, suppliersfilter, modelsfilter]">
              <MachineTypeSelect v-model="machinetypesfilter" multiple clearable externaledit class="mb-3">
              </MachineTypeSelect>
              <SupplierSelect v-model="suppliersfilter" multiple clearable externaledit class="mb-3">
              </SupplierSelect>
              <ModelSelect v-model="modelsfilter" multiple clearable externaledit class="mb-3">
              </ModelSelect>
              <MachineSelect v-model="machinefilter" clearable multiple externaledit>
              </MachineSelect>
            </FilterGroup>

            <FilterGroup v-if="!hideOwnershipFilters" :title="$t('servicesystem.common_objects.customer.ownership')"
              :open="false"
              :applied-filters="[customerfilter, invoicecustomerfilter, parentcustomerfilter, customergroupfilter]">
              <CustomerSelect v-model="customerfilter" clearable multiple externaledit class="mb-3">
              </CustomerSelect>
              <CustomerSelect v-model="invoicecustomerfilter"
                :label="$t('servicesystem.common_objects.job.invoice_customer')" clearable multiple externaledit
                class="mb-3">
              </CustomerSelect>
              <CustomerSelect v-model="parentcustomerfilter"
                :label="$t('servicesystem.common_objects.customer.parent_org')" clearable multiple externaledit
                class="mb-3">
              </CustomerSelect>
              <!--
              customer group <br>
              -->
            </FilterGroup>

            <FilterGroup v-if="!hideAppointmentFilters" :open="routeFilter == 'my'"
              :title="$t('servicesystem.common_objects.appointment.appointments')"
              :applied-filters="[onlyminefilter, userfilter, datefilter, departmentfilter]">
              <v-checkbox v-model="onlyminefilter" :label="$t('servicesystem.common_objects.job.only_mine')" dense
                hide-details class="pt-0 mt-n1 ml-n1 mb-3">
              </v-checkbox>
              <UserSelect v-model="userfilter" :filter="userfilterFilter" clearable multiple externaledit
                class="mb-3 mt-0">
              </UserSelect>
              <!--
              User <br>
              Date <br>
              Department <br>
              -->
            </FilterGroup>

            <FilterGroup v-if="!hideOrderFilters" :title="$t('servicesystem.common_objects.order.orders')" :open="false"
              :applied-filters="[orderdepartmentfilter, jobcategoryfilter, articlesfilter]">
              <v-row no-gutters class="mr-2">
                <v-col cols="11">
                  <DepartmentSelect v-model="orderdepartmentfilter" clearable multiple externaledit class="mb-3 mt-0">
                  </DepartmentSelect>
                </v-col>
                <v-col cols="1" class="pt-3">
                  <v-btn icon small :color="orderdepartmentfilterIsDefault ? 'primary' : 'disabled'"
                    @click="setStoredOrderDeparmentDefault()">
                    <v-icon>mdi-star</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <!--
              JobCategory <br>
                      -->
              <ArticleSelect v-model="articlesfilter" clearable multiple externaledit class="mb-3">
              </ArticleSelect>
            </FilterGroup>

          </template>

          <template v-slot:sorting-content>
            <SortingContent :key="routeFilter" :pk="pk" :sortablefields="sortablefields" :defaultsort="defaultsort">
            </SortingContent>
          </template>

        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getJobListFromFilter" :locked-filters="lockedFilters" :optional-filters="filters"
          :paginationEnabled="true" :show-filter-tab="true" :show-sorting-tab="true" :itemsPerPage="40" ref="ListPane"
          :openFunction="openItem" :pk="pk" :exportFunction="exportFunc">

          <template v-if="$route.query[pk + 'filter'] === undefined && filterChips && filterChips.length"
            v-slot:prepend-item>
            <v-row no-gutters class="ignoreodd px-3" align="center"
              style="border-bottom: 1px solid var(--v-disabled-base);">
              <p class="mb-0 mr-2">{{ $t('servicesystem.common_objects.commonterms.filtered_by') }}:</p>
              <v-chip-group>
                <v-chip v-for="chip in filterChips" :key="chip.name" color="primary" small :close="!chip.disabled"
                  close-icon="mdi-close" @click:close="chip.onclick">
                  {{ chip.name }}
                </v-chip>
              </v-chip-group>
            </v-row>
          </template>

          <template v-slot:list-item="{ item }">
            <ListItem :jobItem="item" :preselected="($route.query.jobId == item.Id)" previewable
              :draggable="$route.name == 'JobList'" showStatus>
              <!--
              @click="openItem(item)" :set-preview-function="openPreview" @openPreview="openPreview(item)"
              @closePreview="closePreview()"
              -->
            </ListItem>

          </template>

        </ListPane>
      </template>

      <template v-slot:preview>
        <PreviewPane :id="$route.query.jobId" :showToolbar="true" />
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterGroup from "@/components/FilterGroup.vue";
import ArticleSelect from "@/components/Inputs/EntityDropdowns/ArticleSelect2.vue";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import JobStatusSelect from "@/components/Inputs/EntityDropdowns/JobStatusSelect2.vue";
import ModelSelect from "@/components/Inputs/EntityDropdowns/MachineModelSelect2.vue";
import MachineSelect from "@/components/Inputs/EntityDropdowns/MachineSelect2.vue";
import MachineTypeSelect from "@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue";
import RepairCodeSelect from "@/components/Inputs/EntityDropdowns/RepairCodeSelect2.vue";
import UserSelect from "@/components/Inputs/EntityDropdowns/UserSelect2.vue";
import SupplierFailureCodeSelect from "@/components/Inputs/EntityDropdowns/SupplierFailureCodeSelect2.vue";
import SupplierSelect from "@/components/Inputs/EntityDropdowns/SupplierSelect2.vue";
import ListItem from "@/components/ListItems/JobListItem/JobListItem3.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import PreviewPane from "@/components/Sections/Panes/PreviewJob.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";
//import JobCategorySelect from "@/components/JobCategorySelect2.vue";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import JobSubStatusSelect from "@/components/Inputs/EntityDropdowns/JobSubStatusSelect2.vue";
import SortingContent from "@/components/Sections/Panes/SortingContent.vue";

export default {
  name: "AdminJobList",
  props: {
    hideJobDetailsFilters: Boolean,
    hideProductFilters: Boolean,
    hideOwnershipFilters: Boolean,
    hideAppointmentFilters: Boolean,
    hideOrderFilters: Boolean,
    lockedFilters: Object,
  },
  components: {
    FilterPane,
    ListPane,
    PreviewPane,
    Layout,
    ListItem,
    FilterGroup,
    CustomerSelect,
    MachineSelect,
    ModelSelect,
    SupplierSelect,
    MachineTypeSelect,
    SupplierFailureCodeSelect,
    RepairCodeSelect,
    ArticleSelect,
    //JobCategorySelect,
    JobStatusSelect,
    JobSubStatusSelect,
    DepartmentSelect,
    SortingContent,
    UserSelect,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "AJL-",
      orderDeparmentChangedPostMount: false,
      hidecompletedjobsChangedPostMount: false,

      sortablefields: [
        { Field: "CreatedDate", displayString: this.$t("servicesystem.common_objects.job.created") },
        //{ Field: "OrderId", displayString: this.$t("servicesystem.common_objects.order.order_id") },
        { Field: "JobPriorityId", displayString: this.$t("servicesystem.common_objects.job.priority") },
        { Field: "JobTypeId", displayString: this.$t("servicesystem.common_objects.job.type") },
        { Field: "JobStatusId", displayString: this.$t("servicesystem.common_objects.job.status") },
        { Field: "JobSubStatusId", displayString: this.$t("servicesystem.common_objects.job.substatus") },
        { Field: "EstimatedTime", displayString: this.$t("servicesystem.common_objects.job.time_estimate") },
        { Field: "Customer.Name", displayString: this.$t("servicesystem.common_objects.customer.customer_name") },
        { Field: "CustomerId", displayString: this.$t("servicesystem.common_objects.customer.customer_number") },
      ],

      userfilterFilter: {
        OnlyBookable: true,
      },

      defaultsort: [
        { Field: "CreatedDate", Direction: 1 },
      ],
    };
  },

  created() {
    //this.$store.dispatch("JobHub/JobPreview/setPreviewJob", null);
  },

  mounted() { },

  methods: {
    /*
    openPreview(item) {
      var query = Object.assign({}, this.$route.query);
      query.jobId = item.Id;
      this.$router.replace({ query });
      this.$store.dispatch("JobHub/JobPreview/getPreviewJob", item.Id);
    },
    closePreview() {
      var query = Object.assign({}, this.$route.query);
      query.jobId = undefined;
      this.$router.replace({ query });
      this.$store.dispatch("JobHub/JobPreview/setPreviewJob", null);
    },
    */
    openItem(item) {
      //console.log("openItem", item);
      var query = (this.$route.name == "JobList") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewJob', params: { jobId: item.Id }, query })
    },

    handleadded: (item) => this.$refs.ListPane.handleadded(item),
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    exportFunc(filters) {
      this.exportJobListFromFilter(filters);
    },

    setStoredOrderDeparmentDefault() {
      if (this.orderdepartmentfilterIsDefault) {
        this.storedOrderDeparmentDefault = null;
      }
      else {
        this.storedOrderDeparmentDefault = Object.assign([], this.orderdepartmentfilter);
      }
    },
  },

  computed: {
    dialogtrigger() { return this.$store.state.triggerevents.newDialogTrigger; },

    PreviewJob() { return this.$store.getters["JobHub/JobPreview/PreviewJob"]; },

    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.seartchfilter,
          //job filters
          JobTypeIdList: this.jobtypefilter,
          HideCompletedJobs: this.hidecompletedjobsfilter,
          JobStatusIdList: this.jobstatusfilter,
          JobSubStatusIdList: this.jobsubstatusfilter,
          JobPriorityIdList: this.jobpriorityfilter,
          SupplierFailureCodeIdList: this.supplierfailurecodefilter,
          RepairCodeIdList: this.repaircodefilter,
          //customer filters
          CustomerIdList: this.customerfilter,
          InvoiceCustomerIdList: this.invoicecustomerfilter,
          ParentCustomerIdList: this.parentcustomerfilter,
          CustomerGroupIdList: this.customergroupfilter,
          //poduct filters
          MachineIdList: this.machinefilter,
          MachineTypeIdList: this.machinetypesfilter,
          SupplierIdList: this.suppliersfilter,
          MachineModelIdList: this.modelsfilter,
          //appointment filters
          OnlyMine: this.onlyminefilter,
          UserIdList: this.userfilter,
          DateList: this.datefilter,
          DepartmentIdList: this.departmentfilter,
          //order filters
          JobCategoryIdList: this.jobcategoryfilter,
          ArticleNumberList: this.articlesfilter,
          OrderDepartmentIdList: this.orderdepartmentfilter,
          Sort: this.sortings,
        };
        console.log('trigger 1')
        return filters;
      }
      else {
        //some filters have default values outside of the query paramters so they should be returned either way
        var filter = {
          OnlyMine: this.onlyminefilter,
          UserIdList: this.userfilter,
          HideCompletedJobs: this.hidecompletedjobsfilter,
          JobTypeIdList: this.jobtypefilter,
          JobStatusIdList: this.jobstatusfilter,
          JobSubStatusIdList: this.jobsubstatusfilter,
          OrderDepartmentIdList: this.orderdepartmentfilter,
          Sort: this.sortings,
        };
        //console.log('trigger 2')
        return filter;
      }
    },

    filterChips() {
      var map = {
        SearchWord: { computedValKey: 'seartchfilter', displayName: this.$t('servicesystem.common_objects.commonterms.search') },
        //job filters
        JobTypeIdList: { computedValKey: 'jobtypefilter', displayName: this.$t('servicesystem.common_objects.job.type') },
        HideCompletedJobs: { computedValKey: 'hidecompletedjobsfilter', displayName: this.$t('servicesystem.common_objects.job.only_not_complete') },
        JobStatusIdList: { computedValKey: 'jobstatusfilter', displayName: this.$t('servicesystem.common_objects.job.status') },
        JobSubStatusIdList: { computedValKey: 'jobsubstatusfilter', displayName: this.$t('servicesystem.common_objects.job.substatus') },
        JobPriorityIdList: { computedValKey: 'jobpriorityfilter', displayName: this.$t('servicesystem.common_objects.job.priority') },
        SupplierFailureCodeIdList: { computedValKey: 'supplierfailurecodefilter', displayName: this.$t('servicesystem.common_objects.supplier_failure_code.supplier_failure_code') },
        RepairCodeIdList: { computedValKey: 'repaircodefilter', displayName: this.$t('servicesystem.common_objects.repair_code.repair_code') },
        //customer filters
        CustomerIdList: { computedValKey: 'customerfilter', displayName: this.$t('servicesystem.common_objects.customer.customer') },
        InvoiceCustomerIdList: { computedValKey: 'invoicecustomerfilter', displayName: this.$t('servicesystem.common_objects.job.invoice_customer') },
        ParentCustomerIdList: { computedValKey: 'parentcustomerfilter', displayName: this.$t('servicesystem.common_objects.customer.parent_org') },
        CustomerGroupIdList: { computedValKey: 'customergroupfilter', displayName: this.$t('servicesystem.common_objects.customer_group.customer_group') },
        //poduct filters
        MachineIdList: { computedValKey: 'machinefilter', displayName: this.$t('servicesystem.common_objects.machine.machine') },
        MachineTypeIdList: { computedValKey: 'machinetypesfilter', displayName: this.$t('servicesystem.common_objects.machine_type.machine_type') },
        SupplierIdList: { computedValKey: 'suppliersfilter', displayName: this.$t('servicesystem.common_objects.supplier.supplier') },
        MachineModelIdList: { computedValKey: 'modelsfilter', displayName: this.$t('servicesystem.common_objects.model.model') },
        //appointment filters
        OnlyMine: { computedValKey: 'onlyminefilter', displayName: this.$t('servicesystem.common_objects.job.only_mine') },
        UserIdList: { computedValKey: 'userfilter', displayName: this.$t('servicesystem.common_objects.user.user') },
        //order filters
        ArticleNumberList: { computedValKey: 'articlesfilter', displayName: this.$t('servicesystem.common_objects.article.article') },
        OrderDepartmentIdList: { computedValKey: 'orderdepartmentfilter', displayName: this.$t('servicesystem.common_objects.department.department') },
        //sorting
        Sort: { computedValKey: 'sortings', displayName: this.$t('servicesystem.common_objects.commonterms.sort') },
      }
      var arr = [];
      Object.keys(this.filters).forEach(key => {
        var value = this.filters[key];
        if (value && (!Array.isArray(value) || value.length && (value.length == 1 && value[0] !== 0))) {
          var config = map[key];
          if (config) {
            var disabled;
            if (this.routeFilter?.includes("status-")
              && (key == "JobStatusIdList" || key == "JobSubStatusIdList")
              && value.length == 1) {
              disabled = true;
            }
            else if (this.routeFilter == "my" && key == "OnlyMine" && value == true) {
              disabled = true;
            }
            else if (this.routeFilter == "parts" && key == "JobTypeIdList" && value.length == 1 && value[0] == 4) {
              disabled = true;
            }
            arr.push({
              name: config.displayName,
              disabled: disabled,
              onclick: () => {
                //console.log("clear", config.computedValKey);
                this[config.computedValKey] = null;
              },
            });
          }
          else {
            console.error('Invalid config for filter', key);
          }

        }
      });

      return arr;
    },

    storedOrderDeparmentDefault: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("JobListFilterOrderDepartmentDefault");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "JobListFilterOrderDepartmentDefault", value: update });
      },
    },

    orderdepartmentfilterIsDefault() {
      return this.orderdepartmentfilter.length &&
        this.orderdepartmentfilter.join("-") == this.storedOrderDeparmentDefault?.join("-");
    },

    statusKey() {
      return this.jobstatusfilter.join("-");
    },

    routeFilter() {
      return this.$route.params.filter;
    },

    routeStatusId() {
      var statusid =
        this.routeFilter?.includes("status-") ?
          parseInt(this.routeFilter.split("-")[1]) || undefined
          : undefined;
      return statusid;
    },

    routeSubStatusId() {
      var substatusid =
        this.routeFilter?.includes("status-") ?
          parseInt(this.routeFilter.split("-")[2])
          : undefined;
      return substatusid;
    },

    seartchfilter: {
      get() { return this.getQueryParam("filter-keyword", undefined); },
      set(update) { this.setQueryParam("filter-keyword", update); },
    },

    //job details filters
    jobtypefilter: {
      get() {
        var value = this.getQueryParam("filter-jobtype", []);
        if (!value.length && this.routeFilter == "parts") {
          value = [4];
        }
        return value;
      },
      set(update) { this.setQueryParam("filter-jobtype", update); },
    },
    hidecompletedjobsfilter: {
      get() {
        var value = this.getQueryParam("filter-showcompletedjobs", undefined);
        if (value === undefined && (this.routeFilter == "my" || this.routeFilter == "parts" || this.routeFilter?.includes("user-")) && !this.hidecompletedjobsChangedPostMount) {
          value = true;
        }
        return value;
      },
      set(update) {
        this.hidecompletedjobsChangedPostMount = true;
        this.setQueryParam("filter-showcompletedjobs", update);
      },
    },
    jobstatusfilter: {
      get() {
        var fromquery = this.getQueryParam("filter-jobstatus", []);
        if (!fromquery.length && this.routeStatusId) {
          return [this.routeStatusId]
        }
        return fromquery;
      },
      set(update) { this.setQueryParam("filter-jobstatus", update); },
    },
    jobsubstatusfilter: {
      get() {
        var fromquery = this.getQueryParam("filter-jobsubstatus", []);
        if (!fromquery.length && this.routeSubStatusId != undefined) {
          return [this.routeSubStatusId]
        }
        return fromquery;
      },
      set(update) { this.setQueryParam("filter-jobsubstatus", update); },
    },
    jobpriorityfilter: {
      get() { return this.getQueryParam("filter-jobpriority", []); },
      set(update) { this.setQueryParam("filter-jobpriority", update); },
    },
    supplierfailurecodefilter: {
      get() { return this.getQueryParam("filter-supplierfailurecode", []); },
      set(update) { this.setQueryParam("filter-supplierfailurecode", update); },
    },
    repaircodefilter: {
      get() { return this.getQueryParam("filter-repaircode", []); },
      set(update) { this.setQueryParam("filter-repaircode", update); },
    },

    //customer filters
    customerfilter: {
      get() { return this.getQueryParam("filter-customer", []); },
      set(update) { this.setQueryParam("filter-customer", update); },
    },
    invoicecustomerfilter: {
      get() { return this.getQueryParam("filter-invociecustomer", []); },
      set(update) { this.setQueryParam("filter-invociecustomer", update); },
    },
    parentcustomerfilter: {
      get() { return this.getQueryParam("filter-parentcustomer", []); },
      set(update) { this.setQueryParam("filter-parentcustomer", update); },
    },
    customergroupfilter: {
      get() { return this.getQueryParam("filter-customergroup", []); },
      set(update) { this.setQueryParam("filter-customergroup", update); },
    },

    //poduct filters
    machinefilter: {
      get() { return this.getQueryParam("filter-machine", []); },
      set(update) { this.setQueryParam("filter-machine", update); },
    },
    machinetypesfilter: {
      get() { return this.getQueryParam("filter-machinetypes", []); },
      set(update) { this.setQueryParam("filter-machinetypes", update); },
    },
    suppliersfilter: {
      get() { return this.getQueryParam("filter-suppliers", []); },
      set(update) { this.setQueryParam("filter-suppliers", update); },
    },
    modelsfilter: {
      get() { return this.getQueryParam("filter-models", []); },
      set(update) { this.setQueryParam("filter-models", update); },
    },

    //appointment filters
    onlyminefilter: {
      get() {
        var value = this.getQueryParam("filter-onlymine", undefined);
        if (value === undefined && this.routeFilter == "my") {
          value = true;
        }
        return value;
      },
      set(update) { this.setQueryParam("filter-onlymine", update); },
    },
    userfilter: {
      get() {
        var value = this.getQueryParam("filter-user", []);
        if (!value.length && this.routeFilter?.includes("user-")) {
          var userId = parseInt(this.routeFilter.split("-")[1]);
          value = [userId];
        }
        return value;
      },
      set(update) { this.setQueryParam("filter-user", update); },
    },
    datefilter: {
      get() { return this.getQueryParam("filter-date", []); },
      set(update) { this.setQueryParam("filter-date", update); },
    },
    departmentfilter: {
      get() { return this.getQueryParam("filter-department", []); },
      set(update) { this.setQueryParam("filter-department", update); },
    },

    //order filters
    jobcategoryfilter: {
      get() { return this.getQueryParam("filter-jobcategory", []); },
      set(update) { this.setQueryParam("filter-jobcategory", update); },
    },
    articlesfilter: {
      get() { return this.getQueryParam("filter-articles", []); },
      set(update) { this.setQueryParam("filter-articles", update); },
    },
    orderdepartmentfilter: {
      get() {
        var value = this.getQueryParam("filter-orderdepartment", []);
        if (!value.length && this.storedOrderDeparmentDefault && !this.orderDeparmentChangedPostMount) {
          return this.storedOrderDeparmentDefault;
        }
        return value;
      },
      set(update) {
        this.orderDeparmentChangedPostMount = true;
        this.setQueryParam("filter-orderdepartment", update);
      },
    },


    sortings() {
      return this.getQueryParam("filter-sorting", []);
    },


    jobPriorityList() {
      var list = this.$store.getters["LookUpStore/JobPriorityList"];
      return list && list.length ? list : [];
    },
    jobTypeList() {
      var list = this.$store.getters["LookUpStore/JobTypeList"];
      return list && list.length ? list : [];
    },
    jobSubStatusList() {
      var list = this.$store.getters["LookUpStore/JobSubStatusList"];
      return list && list.length ? list : [];
    },
  },

  watch: {
    routeFilter: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.orderDeparmentChangedPostMount = false;
        this.hidecompletedjobsChangedPostMount = false;
      }
    },

    storedOrderDeparmentDefault: function () {
      //update ui job counters with filter preference
      this.$store.dispatch("BackgroundUpdater/Checker", "StatusMap");
      //clear filter on joblist on planner to default preference
      this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListDepartmentFilter", value: null });
    },
  },
};
</script>